<template>
  <Section id="builder" tone="default" pad-y="xl" aria-labelledby="builder-heading">
    <Container>
      <h2 id="builder-heading" class="sr-only">{{ t('sections.visualBuilder.title') }}</h2>
      <BuilderBlock
        :heading="t('sections.visualBuilder.title')"
        :subheading="t('sections.visualBuilder.subtitle')"
        :blocks="localizedBlocks"
        :promises="promises"
        :cta-label="t('cta.tryBuilder')"
        @cta="onCta"
      />
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import BuilderBlock from '@/components/domain/BuilderBlock.vue';
import {
  BUILDER_BLOCKS,
  BUILDER_PROMISES,
  BUILDER_PROMISES_EN,
  type BuilderBlockItem,
} from '@/content/home-data';
import { useLocale } from '@/composables/useLocale';
import { pickLocalized } from '@/lib/i18n/localize';
import { yaTrackEvent } from '@/lib/metrics';

const { t } = useI18n();
const { locale } = useLocale();
const router = useRouter();

const localizedBlocks = computed<readonly BuilderBlockItem[]>(() =>
  BUILDER_BLOCKS.map((b) => ({ ...b, title: pickLocalized(b, 'title', locale.value) })),
);

const promises = computed(() => (locale.value === 'en' ? BUILDER_PROMISES_EN : BUILDER_PROMISES));

function onCta(): void {
  yaTrackEvent('NewSiteOpenBrief');
  void router.push(`/${locale.value}/brief`);
}
</script>
